var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInDepthAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458,458H213.67V274.37H458ZM348.23,311.3V421.07h23.85V311.3ZM250.18,421.09h24V311.42h-24Zm170.93.1V348.13H397.22v73.06Zm-98-.08V360.46H299.18v60.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.81,42V249.71H42V42Zm-98,101.17c-1.63-.48-2.51-.76-3.41-1-15.8-4.38-30.67-2.7-43.85,7.51-18.36,14.22-18.54,38.85-.46,53.43,11.07,8.93,23.9,11.71,37.79,9.43,16.72-2.74,35.31-15.56,34.61-39.94-.58-20.15-.12-40.34-.11-60.52,0-1.39.14-2.79.21-4.19l1.38-.76,12.79,13.33L199.58,110c-11.79-24.39-35.31-32-59.73-32.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.62,165.76l17.43-11.52,13.38,20.06c-.9.73-1.66,1.46-2.52,2-12.71,8.5-25.4,17-38.19,25.39-1.09.72-3.24,1.19-4.14.61-13.93-9.07-27.73-18.34-41.93-27.8l13.53-20.32,17.06,11.26c0-10.66.88-21-.25-31.06-1.09-9.78-9.81-17-19.59-18.58-1.19-.19-2.37-.42-3.79-.67V91c12.05.2,22.49,4,31.4,11.66,11.53,9.93,17.2,22.67,17.36,37.86.08,6.91,0,13.81,0,20.72C372.4,162.52,372.52,163.81,372.62,165.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.13,346.38,85.52,358,72,337.73l16.27-10.89c8.21-5.49,16.38-11,24.69-16.35,1.14-.73,3.46-1,4.49-.31,13.48,8.77,26.83,17.75,40.21,26.7a8.44,8.44,0,0,1,1,1.13l-13.32,20-17-11.26c0,10.7-1.15,21.21.33,31.33s9,16.26,19.34,18.28c1.06.21,2.13.37,3.2.57.12,0,.22.14.64.4v23.87a46.63,46.63,0,0,1-27.71-8.86c-13.69-9.8-20.59-23.33-21-40.1C103,363.91,103.13,355.55,103.13,346.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.76,163.21c4.93,2,9.9,3.17,13.89,5.81,5.76,3.81,5.52,10.65.26,15.15-7.25,6.18-21.52,6.18-28.73,0-5.45-4.68-5.55-11.5.54-15.36C111.77,166.23,116.75,165.13,121.76,163.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInDepthAnalytics);
export default __webpack_public_path__ + "static/media/In-Depth Analytics.fa632127d13498829679a613aa230469.svg";
export { ForwardRef as ReactComponent };